import { buildUrlFromLocation } from "@/utils/httpUtils";
import http from "@/services/http";

export default {
    async getHistories(objectType, objectId) {
        return await http.get(buildUrlFromLocation(`/histories?objectType=${objectType}&objectId=${objectId}`, { campaignId: null }));
    },
    async post(history) {
        return await http.post(buildUrlFromLocation(`/histories`, { campaignId: null }), history);
    }
};



// WEBPACK FOOTER //
// ./src/services/history.js